// extracted by css-extract-rspack-plugin
export default {"root":"root-So3jpO","inventoryTableContainer":"inventoryTableContainer-q9aBnR","inventoryViewer":"inventoryViewer-Q96hs1 text-base"};